import React, { useContext } from 'react';
import { Box } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import Accordions from './Accordions';
import Context from './service/Context';
import useSpecifications from '../../apiHooks/useSpecifications';
import { SplideSlideBadgeLabel as BadgeLabel } from './TrimSpecifications.styles';
import { getCategorizedSpecifications, getPageCount } from './service/utils';
const SpecificationsUI = ({ items, expandLabel, collapseLabel, specificationRefs, itemParentGroup, }) => {
    const configurationProvider = useContext(Context);
    const { slidePerPage, setCurrentSlide, isMobile, vehicleType, getItemId } = configurationProvider || {};
    // Adjust accordion "offset" (i.e. sticky position of category title)
    // based on presence of pagination.
    const pageCount = getPageCount(items, isMobile, slidePerPage);
    const multiPageOffsetDesktopHeight = 240;
    const multiPageOffsetMobileHeight = 115;
    const singlePageOffsetDesktopHeight = 200;
    const singlePageOffsetMobileHeight = 70;
    const multiPageOffset = !isMobile ? multiPageOffsetDesktopHeight : multiPageOffsetMobileHeight;
    const singlePageOffset = !isMobile ? singlePageOffsetDesktopHeight : singlePageOffsetMobileHeight;
    const accordionOffset = pageCount > 1 ? multiPageOffset : singlePageOffset;
    const { specifications, isFetching } = useSpecifications({
        trims: items === null || items === void 0 ? void 0 : items.map(getItemId),
        vehicleType,
    });
    if (!specifications || isFetching) {
        return null;
    }
    const categorizedSpecifications = getCategorizedSpecifications(specifications, items, getItemId);
    const printItemsList = items === null || items === void 0 ? void 0 : items.map(item => {
        var _a, _b, _c;
        return (React.createElement(BadgeLabel, { size: "regular", key: (_a = item.trimName) === null || _a === void 0 ? void 0 : _a.value }, compiler(((_b = item.trimName) === null || _b === void 0 ? void 0 : _b.value) || ((_c = item.modelName) === null || _c === void 0 ? void 0 : _c.value))));
    });
    return (React.createElement(Box, { className: "trim-specifications-accordion" },
        React.createElement(Accordions, { refs: specificationRefs, onDrag: (_, slide) => {
                setCurrentSlide(slide.index);
            }, specifications: categorizedSpecifications, collapseLabel: collapseLabel === null || collapseLabel === void 0 ? void 0 : collapseLabel.value, expandLabel: expandLabel === null || expandLabel === void 0 ? void 0 : expandLabel.value, offset: accordionOffset, itemParentGroup: itemParentGroup, printItemsList: printItemsList })));
};
export default SpecificationsUI;
